import { useEffect, useState, useRef } from "react";
import { useHistory } from "react-router-dom";
import { useFormik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { AiOutlineArrowLeft } from "react-icons/ai";
import {
  getProfile,
  editUserProfile,
  uploadProfilePicture,
} from "../../../actions/profile.action";
import { HiPencilAlt } from "react-icons/hi";
import { Loading } from "../../../utils/helpers/constants";
import CustomInput from "../../../components/CustomInput";
import RoundLoader from "../../../components/loader/RoundLoader";
import logout from "../../../assets/images/png/logout.png";
import { logOutUser } from "../../../actions/auth.action";
import DocumentTable from "./DocumentTable";
import { getAttachedDocuments } from "../../../actions/document.action";
import AttachDocumentModal from "../../../components/modals/AttachDocumentModal";
// import { replaceString } from "../../../utils/helpers/dataHelper";

export default function Profile() {
  const history = useHistory();
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const cancelButtonRef = useRef(null);

  useEffect(() => {
    dispatch(getProfile());
    dispatch(getAttachedDocuments());
  }, []);

  const [error, setError] = useState({
    imageUrl: "",
  });

  const {
    profile: {
      profileImage,
      userProfileLoading,
      userData,
      profileImageLoading,
      editProfileStatus,
    },
  } = useSelector(({ profileReducer }) => ({
    profile: profileReducer,
  }));

  console.log("userData?.links  ", userData?.links);
  const {
    document: { attachDocumentList },
  } = useSelector(({ documentReducer }) => ({
    document: documentReducer,
  }));

  const onImageUpload = (event) => {
    if (event.target.files && event.target.files[0]) {
      let reader = new FileReader();
      let file = event.target.files[0];
      reader.onloadend = () => {
        handlePhotoSubmit(file);
      };
      reader.readAsDataURL(file);
    }
  };

  const logOut = () => {
    dispatch(logOutUser());
  };

  const handlePhotoSubmit = (imageFile) => {
    // const imageFile = imageDetails.file;
    if (imageFile !== "") {
      const navigateLink = () => history.push("/onboarding/create-password");
      dispatch(uploadProfilePicture(imageFile, navigateLink));
    } else {
      setError({
        ...error,
        imageUrl: "Please upload your profile picture",
      });
    }
  };

  const profileState =
    userProfileLoading === Loading.FETCHING ||
    editProfileStatus === Loading.FETCHING ||
    profileImageLoading === Loading.FETCHING;

  const { handleSubmit, handleChange } = useFormik({
    initialValues: {
      // address1: address1,
      // address2: "",
      phoneNumber: userData.phoneNumber,
      emailAddress: userData.emailAddress,
      bio: userData.bio,
    },
    onSubmit(values) {
      const payload = {
        address1: values.address1,
        address2: values.address2,
        phoneNumber: values.phoneNumber,
        emailAddress: values.emailAddress,
        bio: values.bio,
      };
      console.log({ payload });
      dispatch(editUserProfile(payload));
    },
  });

  return (
    <div>
      {profileState ? (
        <RoundLoader />
      ) : (
        <>
          <div className="doc_processing_color h-40 px-2 pt-3">
            <AiOutlineArrowLeft
              size={25}
              onClick={() => history.goBack()}
              className="mb-2 cursor-pointer"
            />
            <div className="text-md">
              <span className="text-2xl text-green-800 font-serif font-bold">
                User Profile
              </span>
            </div>
          </div>

          <div className="p-4 md:flex gap-10">
            <div className="md:w-4/12 mb-10">
              <div className="flex flex-row justify-center mb-1 px-5 border-black">
                <img
                  className="w-32 md:w-48 h-32 md:h-48 mr-4 rounded-full border-black	bg-green-50"
                  src={profileImage}
                  loading="lazy"
                  alt="profile_picture"
                />
              </div>
              <div className="flex justify-center mb-5">
                <label className="cameraButton rounded-lg cursor-pointer">
                  <div
                    style={{ marginTop: "-50px", marginLeft: "100px" }}
                    className="bg-white rounded-full p-2 border"
                  >
                    <HiPencilAlt size={25} color={"green"} />
                  </div>
                  <input
                    type="file"
                    accept="image/*;capture=camera"
                    onChange={(e) => onImageUpload(e)}
                    name={"imageUrl"}
                  />
                </label>
              </div>
              <div className="bg-gray-50 p-5">
                <div className="text-gray-400 ">
                  {userData.officeType === null
                    ? "Pathfinder"
                    : userData.executiveType}
                </div>
                <div className="name text-">
                  <span className=" text-bold">FullName: </span>
                  {userData.fullName}
                </div>
                <div className="">
                  <span className="">Matric Number: </span>
                  {userData.matricNumber}
                </div>
                <div className="">
                  <span className="">Graduation Year: </span>
                  {userData.graduationYear}
                </div>
                <div className="text-gray-400 mt-3">Socials</div>
                <>
                  {userData?.links !== undefined &&
                    userData?.links !== null && (
                      <>
                        <div>
                          <span className="">Twitter: </span>
                          {userData?.links["twitter"]}
                        </div>
                        <div>
                          <span className="">linkedIn: </span>
                          {userData?.links["linkedIn"]}
                        </div>
                        <div>
                          <span className="">Facebook: </span>
                          {userData?.links["facebook"]}
                        </div>
                      </>
                    )}
                </>
                <hr className="mt-5" />
                <div className="mt-2 cursor-pointer flex" onClick={logOut}>
                  <img src={logout} className="h-5 w-5" alt="logout" />
                  <div className="ml-2 text-red-800">Logout</div>
                </div>
              </div>
            </div>

            <div className="w-full bg-gray-50 pb-10 rounded-md">
              <div className="w-full bg-gray-50 pb-10 rounded-md">
                <div className="bg-green-800 py-2 rounded-t-md px-5 text-white font-bold text-lg mb-5">
                  User information
                </div>
                <div>
                  <form className="px-5">
                    <div className="">
                      <div className="">Email</div>
                      <div className="mt-2">
                        <CustomInput
                          handleChange={handleChange}
                          name="emailAddress"
                          // placeholder="Enter your email"
                          defaultValue={userData.emailAddress}
                        />
                      </div>
                    </div>
                    <div className="mt-0">
                      <div className="">Contact</div>
                      <div className="mt-2">
                        <CustomInput
                          handleChange={handleChange}
                          name="phoneNumber"
                          // placeholder="Enter phone number"
                          defaultValue={userData.phoneNumber}
                          // placeholder={userData.phoneNumber}
                        />
                      </div>
                    </div>
                    <div className="mt-0">
                      <div className="">About</div>
                      <textarea
                        className="mt-2 appearance-none border border-gray-400 rounded w-full pt-4 pb-4 py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-green-800"
                        id="inline-full-name"
                        type="textarea"
                        name="bio"
                        rows={5}
                        onChange={handleChange}
                        defaultValue={userData.bio}
                      />
                    </div>

                    <div>
                      <div className="">Address</div>
                      <textarea
                        className="mt-2 appearance-none border border-gray-400 rounded w-full pt-4 pb-4 py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-green-800"
                        id="inline-full-name"
                        type="textarea"
                        name="address1"
                        rows={5}
                        onChange={handleChange}
                        defaultValue={
                          userData?.addresses !== undefined
                            ? userData?.addresses[0]?.locationAddress
                            : ""
                        }
                      />
                    </div>
                  </form>
                  <div className="flex justify-center mt-5">
                    <button
                      className="mt-2 bg-green-800 py-1 px-2 rounded-md text-white px-10 py-2 text-center"
                      onClick={handleSubmit}
                    >
                      Update
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="p-4 md:flex gap-10">
            <div className="md:w-4/12 mb-10 bg-gree-800"></div>
            <div className="w-full bg-gray-50 pb-10 rounded-md md:w-9/12  bg-re-800">
              <div className="bg-green-800 py-2 rounded-t-md px-5 text-white font-bold text-lg mb-5">
                User Documents
              </div>
              <div className="px-5">
                <DocumentTable
                  list={attachDocumentList}
                  handleCreate={() => setOpen(true)}
                />
              </div>
            </div>
          </div>
          <AttachDocumentModal
            open={open}
            setOpen={setOpen}
            cancelButtonRef={cancelButtonRef}
          />
        </>
      )}
    </div>
  );
}
